<template>
  <div class="role-container" :class="[zsTjTheme]">
    <div :class="['role-img', getItemBg(baseInfo)]">
      <img
        v-if="currentStyle && currentStyle.icon1 && currentStyle.icon1.value"
        :src="currentStyle.icon1.value"
        alt=""
      />
    </div>
    <div class="info-box">
      <div class="top-info">
        <div class="left">
          <div class="title">
            <span class="skin-name">{{ currentStyle.name && currentStyle.name.value }}</span>
            <span>{{ character.name && character.name.value }}</span>
          </div>
          <div class="advice">
            <span v-if="isEdit || (currentShowData && currentShowData.must_take)" class="tag" data-map-key="must_take">
              {{ currentShowData && currentShowData.must_take ? getCurrentLangValue(currentShowData.must_take) : "-" }}
            </span>
            <span
              v-if="isEdit || (currentShowData && currentShowData.must_take_value)"
              class="info"
              data-map-key="must_take_value"
            >
              {{
                currentShowData && currentShowData.must_take_value
                  ? getCurrentLangValue(currentShowData.must_take_value)
                  : "-"
              }}
            </span>
          </div>
        </div>
        <div
          v-if="isEdit || (currentShowData && currentShowData.level)"
          class="right"
          :class="{ active: currentShowData && currentShowData.level }"
          data-map-key="level"
        >
          <!-- <img v-if="currentShowData && currentShowData.level" :src="getLevelImg(currentShowData.level)" alt="" /> -->
          <!--<span-->
          <!--  v-if="currentShowData && currentShowData.level"-->
          <!--  :class="['text', { special: getCurrentLangValue(currentShowData.level) === '神' }]"-->
          <!--  >{{ getCurrentLangValue(currentShowData.level) }}</span-->
          <!--&gt;-->
          <img
            v-if="currentShowData && currentShowData.level"
            :src="matchImg(currentShowData.level)"
            alt=""
            class="strength-img"
          />
          <span v-else class="text">
            -
          </span>
          <!-- <span :class="['text', { 'light-text': currentShowData.level && currentShowData.level === 'T0' }]">
            {{ currentShowData && currentShowData.level ? currentShowData.level : "-" }}
          </span> -->
        </div>
      </div>
      <div class="property-box">
        <div v-for="item in propertyData" :key="item.labelKey" class="item">
          <span class="label" :data-map-key="item.labelKey">
            {{
              currentShowData && currentShowData[item.labelKey]
                ? getCurrentLangValue(currentShowData[item.labelKey])
                : item.label
            }}
          </span>
          <span class="value" :data-map-key="item.valueKey">
            {{
              currentShowData && currentShowData[item.valueKey]
                ? getCurrentLangValue(currentShowData[item.valueKey])
                : "-"
            }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    currentStyle: {
      type: Object,
      default: () => {
        return {};
      }
    },
    baseInfo: {
      type: Object,
      default: () => {
        return {};
      }
    },
    currentShowData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  computed: {
    ...mapGetters(["zsTjTheme", "language"]),
    character() {
      return (this.baseInfo && this.baseInfo.character) || {};
    }
  },
  data() {
    return {
      propertyData: [
        { label: this.$t("tj.zs.生命力"), labelKey: "gjlLabel", valueKey: "gjlValue" },
        { label: this.$t("tj.zs.防御力"), labelKey: "fylLabel", valueKey: "fylValue" },
        { label: this.$t("tj.zs.魔法力"), labelKey: "mflLabel", valueKey: "mflValue" },
        { label: "PVP", labelKey: "pvpLabel", valueKey: "pvpValue" }
      ]
    };
  },
  methods: {
    getLevelImg(level) {
      if (this.zsTjTheme == "light") {
        return require(`@/assets/zs_imgs/light-level-icon-${level}.png`);
      }
      return require(`@/assets/zs_imgs/level-icon-${level}.png`);
    },
    getItemBg(data) {
      const attr = data.character.attr1.name.value;
      if (attr === "火") {
        return "red";
      } else if (attr === "光") {
        return "yellow";
      } else if (attr === "水") {
        return "blue";
      } else if (attr === "暗") {
        return "purple";
      } else if (attr === "风") {
        return "green";
      }
      return "";
    },
    getCurrentLangValue(data) {
      if (data) {
        if (typeof data === "string") {
          return data;
        }
        return this.language ? data[this.language] : "";
      }
      return "";
    },
    matchImg(level) {
      return require(`@/assets/zs_imgs/${this.getCurrentLangValue(level)}.png`);
    }
  }
};
</script>
<style lang="less" scoped>
.role-container {
  display: flex;
  width: 100%;
  margin-bottom: 32px;
  .role-img {
    width: 170px;
    height: 170px;
    margin-right: 34px;
    border-radius: 4px;
    overflow: hidden;
    background-size: cover;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 150%;
      height: 150%;
      object-fit: cover;
    }
  }
  .info-box {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .top-info {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .left {
        flex: 1;
        overflow: hidden;
        .title {
          line-height: 1;
          margin-bottom: 16px;
          font-weight: bold;
          font-size: 28px;
          color: #ffffff;
          .skin-name {
            margin-right: 10px;
          }
        }
        .advice {
          display: flex;
          align-items: center;
          font-weight: bold;
          font-size: 18px;
          color: #ffffff;
          .tag {
            height: 25px;
            margin-right: 9px;
            padding: 0 8px;
            font-weight: bold;
            font-size: 16px;
            line-height: 25px;
            color: rgba(255, 106, 106, 1);
            background: #fff;
            border-radius: 2px;
            box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.1);
          }
          .info {
            min-width: 50px;
          }
        }
      }
      .right {
        // display: flex;
        // justify-content: center;
        // align-items: center;
        flex: 0 0 auto;
        min-width: 48px;
        padding: 0 6px;
        height: 48px;
        line-height: 48px;
        text-align: center;
        border-radius: 4px;
        background: rgba(255, 255, 255, 0.15);
        //img {
        //  width: 36px;
        //  height: 24px;
        //}

        .strength-img {
          width: 77px;
          height: 44px;
        }
        .text {
          font-weight: bold;
          font-size: 24px;
          color: #fff;
        }
      }
    }
    .property-box {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 12px 10px;
      .item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 226px;
        height: 36px;
        padding: 0 10px;
        border: 1px solid #343434;
        border-radius: 4px;
        box-sizing: border-box;
        .label {
          font-weight: bold;
          font-size: 18px;
          color: #ffffff;
        }
        .value {
          min-width: 18px;
          text-align: right;
          font-weight: bold;
          font-size: 20px;
          color: #ffbc52;
        }
      }
    }
  }
}

.role-container.light {
  .info-box {
    .top-info {
      .left {
        .title {
          font-weight: bold;
          color: #333333;
          margin-bottom: 12px;
        }
        .advice {
          font-weight: bold;
          color: #333333;
        }
      }
      .right {
        background: rgba(136, 183, 201, 0.2);
        border: 1px solid #cccccc;
        &.active {
          background: transparent;
          border: none;
        }
        .text {
          color: #333333;
          &.special {
            color: #ff6600;
          }
        }
      }
    }
    .property-box {
      .item {
        border: 1px solid #cccccc;
        .label {
          font-weight: bold;
          color: #392e25;
        }
        .value {
          color: #ff6600;
        }
      }
    }
  }
}
</style>
